import { createSelector } from 'redux-starter-kit';
import { MetaType } from '../Meta/types';
import { PolicyType } from '../Policies/types';

const portfolioBuilderSelector = (state: any) => state.portfolioBuilder;
const policyTypesMeta = (state: any) => state.meta.policyTypes;
const policyProviderMeta = (state: any) => state.meta.policyProviders;
const riskAssetAllocationSelector = (state: any) =>
  state.meta.riskAssetAllocations;
const riskProfileSelector = (state: any) => state.portfolioBuilder.riskSummary;

export const portfolioBuilderSelectors = {
  policy: createSelector(portfolioBuilderSelector, subState => subState.policy),
  policyType: createSelector(
    [policyTypesMeta, portfolioBuilderSelector],
    (policyTypes: Array<MetaType>, { policy }: { policy: PolicyType }) => {
      const filteredTypes = policyTypes.filter(
        (type: MetaType) => Number(type.value) === policy.type
      );
      return filteredTypes[0] && filteredTypes[0].name;
    }
  ),
  policyProvider: createSelector(
    [policyProviderMeta, portfolioBuilderSelector],
    (policyProviders: Array<MetaType>, { policy }: { policy: PolicyType }) => {
      const filteredProviders = policyProviders.filter(
        (provider: MetaType) => Number(provider.value) === policy.provider
      );
      return filteredProviders[0] && filteredProviders[0].name;
    }
  ),
  policyOwner: createSelector(
    portfolioBuilderSelector,
    subState => subState.policy.owner
  ),
  cipFunds: createSelector(
    portfolioBuilderSelector,
    subState => subState.cipFunds
  ),
  cipTemplate: createSelector(
    portfolioBuilderSelector,
    subState => subState.cipTemplate
  ),
  riskSummary: createSelector(riskProfileSelector, riskProfile => ({
    timeHorizon: riskProfile.time_horizon_interval,
    recommendedRiskProfile: riskProfile.recommended_risk_profile
  })),
  riskAllocations: createSelector(
    riskProfileSelector,
    riskAssetAllocationSelector,
    (riskProfile, riskAssetAllocationSelector) => {
      const { time_horizon_interval, recommended_risk_profile } = riskProfile;

      const filteredData = riskAssetAllocationSelector.filter((risk: any) => {
        const riskLevel = Number(recommended_risk_profile);
        return (
          risk.risk_level === riskLevel &&
          risk.time_horizon === Number(time_horizon_interval)
        );
      });

      return filteredData.length > 0 ? filteredData[0].allocations : [];
    }
  )
};
